import { render, staticRenderFns } from "./MsgElementBusinessCard.vue?vue&type=template&id=4733aa97&scoped=true"
import script from "./MsgElementBusinessCard.vue?vue&type=script&lang=js"
export * from "./MsgElementBusinessCard.vue?vue&type=script&lang=js"
import style0 from "./MsgElementBusinessCard.vue?vue&type=style&index=0&id=4733aa97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4733aa97",
  null
  
)

export default component.exports